"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { fontSize } from "../../../../core/design-system/index.js";
import { useChainSymbol } from "../../../../core/hooks/others/useChainQuery.js";
import { isNativeToken, } from "../../ConnectWallet/screens/nativeToken.js";
import { Skeleton } from "../Skeleton.js";
import { Text } from "../text.js";
/**
 * @internal
 */
export function TokenSymbol(props) {
    if (!isNativeToken(props.token)) {
        return (_jsx(Text, { size: props.size, color: props.color || "primaryText", inline: props.inline, children: props.token.symbol }));
    }
    return (_jsx(NativeTokenSymbol, { chain: props.chain, size: props.size, color: props.color, inline: props.inline }));
}
function NativeTokenSymbol(props) {
    const chainSymbolQuery = useChainSymbol(props.chain);
    if (chainSymbolQuery.isLoading) {
        return _jsx(Skeleton, { width: "70px", height: fontSize[props.size] });
    }
    return (_jsx(Text, { size: props.size, color: props.color || "primaryText", inline: props.inline, children: chainSymbolQuery.symbol ?? "ETH" }));
}
//# sourceMappingURL=TokenSymbol.js.map